/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Display_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Display Profile" |
*
* @param {Styles_Display_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_display_aria_label = /** @type {((inputs?: Styles_Display_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Display_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profil d'affichage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzeigeprofil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza profilo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отображение профиля")
	if (locale === "es") return /** @type {LocalizedString} */ ("Perfil de visualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示配置文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ディスプレイプロフィール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोफ़ाइल प्रदर्शित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exibir perfil")
	return /** @type {LocalizedString} */ ("Display Profile")
});